import * as React from 'react';

import {Body} from '../../typography/body';

import styles from './account-card-contents.module.css';

type Props = {
    description: string | null | undefined;
    location: string | null | undefined;
    phoneNumber?: string | null | undefined;
    phoneExtension?: string | null | undefined;
    phoneContent?: React.ReactNode;
    role?: string | null | undefined;
};

export function AccountCardContents(props: Props) {
    const renderPhone = () => {
        if (props.phoneContent) {
            return <div className='flex align-center gap-4'>{props.phoneContent}</div>;
        }

        if (!props.phoneNumber) {
            return null;
        }

        return (
            <Body size='small' as='div'>
                {props.phoneNumber} {props.phoneExtension && `ext. ${props.phoneExtension}`}
            </Body>
        );
    };

    return (
        <div className='flex flex-dir-col gap-2'>
            {props.role && (
                <Body size='small' as='div' wrapAnywhere={true} title={props.role}>
                    {props.role}
                </Body>
            )}
            {props.description && (
                <div className={styles['description-container']}>
                    <Body size='small' as='div' wrapAnywhere={true} title={props.description}>
                        {props.description}
                    </Body>
                </div>
            )}
            {renderPhone()}
            <Body size='small' as='div' color='placeholder' wrapAnywhere={true}>
                {props.location ? props.location : 'No location'}
            </Body>
        </div>
    );
}
